import { ApplicationConfig, importProvidersFrom, inject, provideAppInitializer } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { routes } from './app.routes';
import { HttpClient, HttpRequest, provideHttpClient, withInterceptors } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { BlockUIModule } from 'ng-block-ui';
import { BlockUIHttpModule } from 'ng-block-ui/http';
import { tokenInterceptor } from './shared/_interceptors/token.interceptor';
import { httpLogInterceptor } from './shared/_interceptors/http-log.interceptor';
import { errorInterceptor } from './shared/_interceptors/error.interceptor';
import { ConfigService } from './shared/_services/config.service';
import { ThemeService } from './shared/_services/theme.service';
import { TENANT_MAP } from './core/tenant.config';
import { provideTranslateService } from '@ngx-translate/core';
import { registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';

export function createTranslateLoader(http: HttpClient) {
	return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

registerLocaleData(localeIt);

// Configura tutte le richieste che non devono essere bloccate da BlockUI
export function filtroBlockUI(req: HttpRequest<any>): boolean {
	if (req.url.includes('noBlock')) {
		return true;
	}
	return false;
}

export function configServiceFactory(http: HttpClient, configService: ConfigService) {
	return () => configService.load(http);
}

export function initLingua(config: ConfigService) {
	return () => config.initLingua();
}

export const appConfig: ApplicationConfig = {
	providers: [
		provideRouter(routes, withInMemoryScrolling({ scrollPositionRestoration: 'top' })),
		provideHttpClient(withInterceptors([tokenInterceptor, httpLogInterceptor, errorInterceptor])),
		provideAppInitializer(() => {
			const initializerFn = configServiceFactory(inject(HttpClient), inject(ConfigService));
			return initializerFn();
		}),
		provideAppInitializer(() => {
      const linguaInit = inject(ConfigService);
      return linguaInit.initLingua();
    }),
		provideAppInitializer(() => inject(ThemeService).loadTenants()),
		provideAppInitializer(() => {
			const themeService = inject(ThemeService);
			const segment = window.location.pathname.split('/').find((s) => s in TENANT_MAP);
			if (segment) {
				themeService.setTenant(TENANT_MAP[segment]);
			} else {
				const params = new URLSearchParams(window.location.search);
				const tenantIdParam = params.get('tenantId');
				if (tenantIdParam) themeService.setTenant(Number(tenantIdParam));
			}
			return themeService.init();
		}),
		provideTranslateService({ loader: { provide: TranslateLoader, useFactory: createTranslateLoader, deps: [HttpClient] } }),
		importProvidersFrom(BlockUIModule.forRoot(), BlockUIHttpModule.forRoot({ requestFilters: [filtroBlockUI] })),
	],
};
